import React from 'react';

interface PercentileFilterProps {
  selectedPercentile: number;
  onPercentileChange: (percentile: number) => void;
}

export const PercentileFilter: React.FC<PercentileFilterProps> = ({
  selectedPercentile,
  onPercentileChange
}) => {
  const percentileOptions = [50, 75, 90, 95, 99];

  return (
    <div className="flex items-center gap-2">
      <label className="text-sm font-medium text-gray-700">
        Percentile:
      </label>
      <select
        value={selectedPercentile}
        onChange={(e) => onPercentileChange(Number(e.target.value))}
        className="px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        {percentileOptions.map((percentile) => (
          <option key={percentile} value={percentile}>
            {percentile}th Percentile
          </option>
        ))}
      </select>
    </div>
  );
};